var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-container"},[_c('p',[_vm._v(_vm._s(this.modalMessage))]),_c('button',{staticClass:"btn",on:{"click":_vm.closeModal}},[_vm._v("Cerrar")])])])}
var staticRenderFns = []

export { render, staticRenderFns }